<gb-floating-button
  icon="add"
  label="STAFF.TUTORIAL_VIDEOS.ADD_TUTORIAL_VIDEO"
  (click)="openAddTutorialVideoDialog()"
></gb-floating-button>

<div class="gb-limit-width setup-tutorial-videos-container">
  <div>
    <h1 translate="STAFF.SIDENAV.TUTORIAL_VIDEOS"></h1>
    <span translate="STAFF.TUTORIAL_VIDEOS.DESCRIPTION"></span>
  </div>
  <gb-table
    [displayedColumns$]="displayedColumns$"
    [tableData$]="allTutorialVideosWithActions$"
    [loaded$]="loaded$"
  ></gb-table>
</div>
